import { RootActions } from 'types/state';

export interface SettingsState {
  /**
   * Not implemented. This will be the replacement for state.application.Settings.
   */
  formType: string
  /**
   * Not implemented. This will be the replacement for state.application.Settings.
   */

  formVersion: string
  /**
   * Not implemented. This will be the replacement for state.application.Settings.
   */

  hasConsented: boolean

  development: {
    /**
     * When enabled, this will show render debug components throughout eApp. This
     * is meant to be used as a tool to assist with troubleshooting performance
     * issues.
     *
     * * Default: false
     */
    showRenderDebugger: boolean

    /**
     * When enabled, this will show all errors under the Field component,
     * regardless of the value for "ShowRequiredErrors".
     *
     * * Default: false
     */
    showAllFieldErrors: boolean

    /**
     * When enabled, this will show debug data associated to the field error
     * messages.
     *
     * * Default: false
     */
    showFieldErrorVerbose: boolean
  }
}

export const initialState: SettingsState = {
  formType: '',
  formVersion: '',
  hasConsented: false,

  development: {
    showRenderDebugger: false,
    showAllFieldErrors: false,
    showFieldErrorVerbose: false,
  },
};

const reducer = (state: SettingsState = initialState, action: RootActions) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default reducer;
